import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../../Components/Admin/assets/icons/a1.png";
import colunms from "../../../../Components/Admin/assets/icons/LINES.png";
import search1 from "../../../../Components/Admin/assets/icons/search.png";
import top from "../../../../Components/Admin/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../../common/ModalDelete";
import {
  AddButton,
  EditButton,
  DeletButton,
  Submit,
} from "../../../common/Button";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ScreenShot from "../../../common/ScreenShot";
import Users from "./Users";
import Reports from "./Reports";
import ExportMethod from "../../../../utils/apis/ExportMethod";
import { formatDate } from "../../../../utils/common";
// import { Context } from "../../../../utils/context";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import Filter_offcanvas from "../../../common/common-offcanvas/Filter_offcanvas";
import { BulkOutward } from "../../../../utils/apis/Outward/Outward";
library.add(fas);

// *****************************************************************************************************

const Tables = () => {
  // hok form
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("file", data.excel[0]);

    const res = await BulkOutward(formData);
    if (res.success) {
      alert("Bulk Payment SuccessFull...!");
      navigate("/bulk-outward");
    } else {
      alert("Something went wrong...!");
    }

    // API call example
    // axios.post("/api/bulk-upload", formData)
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Bulk Payments"} link={"/bulk-outward"} />

        <div className="card mt-3">
          <div className="card-header">
            <h5 className="mb-0">Bulk Payment Upload</h5>
          </div>

          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row align-items-end">
                {/* Excel Upload */}
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Upload Excel Sheet</label>
                    <input
                      type="file"
                      className="form-control"
                      accept=".xls,.xlsx"
                      {...register("excel", {
                        required: "Excel file is required",
                      })}
                    />
                    {errors.excel && (
                      <small className="text-danger">
                        {errors.excel.message}
                      </small>
                    )}
                  </div>
                </div>

                {/* Sample Download */}
                <div className="col-md-3">
                  <label className="d-block">&nbsp;</label>
                  <a
                    href="/sample/bulk-payment-sample.xlsx"
                    download
                    className="btn btn-outline-primary w-100"
                  >
                    Download Sample Sheet
                  </a>
                </div>

                {/* Submit */}
                <div className="col-md-3">
                  <label className="d-block">&nbsp;</label>
                  <button type="submit" className="btn btn-success w-100">
                    Upload
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tables;
